<template>
    <div>
        <b-overlay :show="loading" :variant="'light'" :opacity="0.85" :blur="'2px'" rounded="sm">
            <b-card class="mb-2">
                <div style="text-align: center" class="mt-4">
                    <h1 class="mb-4">Your DocPusher site was created successfully.</h1>
                    <lottie-player src="https://assets3.lottiefiles.com/datafiles/OhIfcxnkLsj1Jxj/data.json" background="transparent" speed="0.5" style="width: 300px; height: 300px; margin: auto;" autoplay></lottie-player>
                </div>
                <hr />
                <div class="mt-2" style="height: 200px">
                    <div class="media">
                        <div class="media-left">
                            <lottie-player class="float-left" src="https://assets4.lottiefiles.com/packages/lf20_F5nRNb.json" background="transparent" speed="0.5" style="margin: 0 15px 0 0;; width: 200px; height: 200px;" loop autoplay></lottie-player>
                        </div>
                        <div class="media-body" style="margin-top: 60px">
                            <h2 class="media-heading">Learn how to use your new DocPusher website in 60 seconds by reading this guide.</h2>
                        </div>
                    </div>
                </div>
                <div class="mb-2" style="text-align: center">
                    <b-button style="margin: auto" v-on:click="back_to_site()" variant="info" class="m-1" size="lg">No thanks, take me to my sites. <i class="fas fa-arrow-right"></i></b-button>
                </div>
                <hr />
                <div class="mt-2">
                    <h2>A dedicated Google Drive folder for this website has been shared with you <i>(check your email)</i>.</h2>
                    <div style="text-align: center" class="mt-4">
                        <img src="../assets/example-shared-drive.png" />
                        <br />
                        <i>Example of the contents of the Google Drive folder shared with you.</i>
                    </div>
                </div>
                <hr />
                <div class="mt-2">
                    <h2>Creating a new Google Doc in the <code>posts</code> or <code>pages</code> folders will create a new website page or blog post <i>(but it won't be immediately published).</i></h2>
                    <div style="text-align: center" class="mt-4">
                        <img src="../assets/create-post-doc-example.png" />
                        <br />
                        <i>The above screenshot is creating a Google Doc in the <code>posts/</code> folder.
                            <br />
                        This doc will be converted into a blog post page when published.</i>
                    </div>
                </div>
                <hr />
                <div class="mt-2">
                    <h2>Once you add or edit a Google Doc in one of these folders, it will be queued for publishing in your DocPusher control panel.</h2>
                    <div style="text-align: center" class="mt-4">
                        <img src="../assets/queued-for-publish.png" />
                        <br />
                        <i>The panel shows what docs have been changed and are ready to push to your website.</i>
                    </div>
                </div>
                <hr />
                <div class="mt-2">
                    <h2>When you're happy with your changes, click the <code>Update from Docs</code> button to push an update to your website.</h2>
                    <div style="text-align: center" class="mt-4">
                        <img src="../assets/push-website-update.png" />
                        <br />
                        <i>Pushing out a website update takes as little as 30 seconds!</i>
                    </div>
                </div>
                <hr />
                <div class="mt-2">
                    <h2><i>P.S.</i> you can change your site settings by clicking the <code>Settings</code> button (settings like site title, social media links, SEO tags, etc)</h2>
                    <div style="text-align: center" class="mt-4">
                        <img src="../assets/change-site-settings.png" />
                        <br />
                        <i>Settings let you tailor your site however you want.</i>
                    </div>
                </div>
                <hr />
                <div style="text-align: center;">
                    
                    <lottie-player src="https://assets7.lottiefiles.com/private_files/lf30_Gh7uJv.json"  background="transparent" padding="0"  speed="0.5"  style="width: 70%; height: 70%; margin: auto"  loop  autoplay></lottie-player>
                    <h1 style="margin-top: -5%; margin-bottom: 5%"><i>That's it! You're ready to start building.</i></h1>
                    <b-button v-on:click="back_to_site()" variant="primary" class="m-1" size="lg">View Site Control Panel <i class="fas fa-arrow-right"></i></b-button>
                </div>
            </b-card>
        </b-overlay>
    </div>
</template>
<script>
export default {
    name: 'SuccessfullyCreateSite',
    props: {},
    data() {
        return {
            loading: false,
        }
    },
    methods: {
        back_to_site() {
            this.$router.push('/sites');
        },
    },
    computed: {

    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>